import React from 'react';
import { ProfilePicture } from '../../../../../styles/stylesStyled';

import { useTranslation } from 'react-i18next';
import { formatVP } from '../../../../../helpers/helperFunctions';
import { CaptionText, H3 } from '../../../../../styles/FontStyles';
import {
  Flexed,
  UserImageCircle
} from '../../../../../styles/GlobalComponents';
import { color } from '../../../../../styles/GlobalStyles';

export const UserProfile = ({
  teamMember,
  teamMemberInfo,
  directTeamMemberInfo
}) => {
  const { t } = useTranslation('myTeam');
  // const hasFullName = teamMember?.name && teamMember.surname;

  function ordinal_suffix_of(i) {
    var j = i % 10,
      k = i % 100;
    if (j === 1 && k !== 11) {
      return i + 'st';
    }
    if (j === 2 && k !== 12) {
      return i + 'nd';
    }
    if (j === 3 && k !== 13) {
      return i + 'rd';
    }
    return i + 'th';
  }

  return (
    <Flexed center column>
      <ProfilePicture
        size={'100px'}
        style={{ marginBottom: 12, marginRight: 0 }}>
        <UserImageCircle
          image={teamMember?.profileImageUrl}
          avatar
          avatarSize='40px'
          size='100px'
        />
      </ProfilePicture>

      <CaptionText center color={color.colors.neutral900}>
        {t('id')}: {teamMember?.id}
      </CaptionText>

      <H3
        center
        mb='10'
        color={color.colors.neutral900}
        style={{ maxWidth: '100%' }}>
        <div className='truncated'>
          <div>{teamMember?.username}</div>
        </div>
      </H3>

      <Flexed>
        <CaptionText center color={color.colors.neutral900}>
          {/* {t('direct_volume')}:{' '} */}
          Unilevel + PO:{' '}
        </CaptionText>
        <CaptionText center bold ml='8' color={color.colors.neutral900}>
          {formatVP(teamMemberInfo?.directTotalVolume)}
        </CaptionText>
      </Flexed>

      {directTeamMemberInfo && directTeamMemberInfo?.generationLevel !== 0 && (
        <div
          style={{
            padding: '4px 8px',
            borderRadius: '8px',
            background: '#2E2A29',
            marginTop: 8
          }}>
          <CaptionText center color={color.colors.neutral50}>
            {ordinal_suffix_of(directTeamMemberInfo?.generationLevel)}{' '}
            {t('generation')}
          </CaptionText>
        </div>
      )}
    </Flexed>
  );
};
